<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Appraisal Level</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Sort Order</b></p>
            <v-text-field outlined dense rounded type="number" v-model="sortorder"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Name</b></p>
            <v-text-field outlined dense rounded type="text" v-model="name"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Marks</b></p>
            <v-text-field outlined dense rounded type="number" v-model="marks"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="ay && name && marks">
          <v-btn class="button" @click="saveApprisalLevel()">Save</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="apprisal_level_list != ''">
        <v-toolbar dense flat class="toolbar">
          <v-toolbar-title>Appraisal Level List</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table dense class="elevation-1 mytable" :headers="headers" :items="bookList1">
          <template v-slot:top class="pb-5">
            <v-row justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row>
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                            color="#0F2027" :label="header.text" multiple clearable
                            :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <span v-if="item.isactive">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editEvaluationParameter(item)">edit</v-icon>
              </v-avatar>
            </div>
          </template>
          <template v-slot:[`item.toggle`]="{ item }">
            <v-switch v-model="item.isactive" @change="saveApprisalLevelIsactive(item)"></v-switch>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialog_edit" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card>
          <v-card class="box">
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Edit Appraisal Level</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-row justify="center" dense>
                <v-col cols="12" md="3" sm="3">
                  <p><b>Sort Order</b></p>
                  <v-text-field rounded type="number" outlined dense v-model="editedItem.sortorder"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                  <p><b>Name</b></p>
                  <v-text-field rounded outlined dense v-model="editedItem.name"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                  <p><b>Max Marks</b></p>
                  <v-text-field rounded type="number" outlined dense v-model="editedItem.marks"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                  <p><b>Isactive</b></p>
                  <v-switch v-model="editedItem.isactive"></v-switch>
                </v-col>
              </v-row>
            </v-card-text>
            <br />
            <v-row justify="center">
              <v-btn class="button" :loading="loader" @click="editApprisalLevel()">Update</v-btn>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="button" @click="dialog_edit = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    criteria: "",
    ay_list: [],
    ay: "",
    marks: "",
    // extraBreadcrumbItems: [
    //   { text: "Appraisal Level", disabled: true, href: "" },

    // ],
    breadcrumbClass: "breadcrumb-style1",
    name: "",
    sortorder: "",
    apprisal_level_list: [],
    dialog_edit: false,
    headers: [
      { text: "Sr No", value: "count" },
      { text: "Sort Order", value: "sort_order" },
      { text: "Name", value: "name" },
      { text: "Marks", value: "marks" },
      { text: "Academic Year", value: "academicyear" },
      { text: "Active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Mark Active/Inactive", value: "toggle" },
    ],
    filters: {
      academicyear: [],
    },
    editedItem: {
      id: "",
      name: "",
      marks: "",
      sortorder: "",
      academicyear: "",
      isactive: "",
    },
  }),
  methods: {
    columnValueList(val) {
      return this.apprisal_level_list.map((d) => d[val]);
    },
    saveApprisalLevelIsactive(item) {
      const data = {
        apprisal_level_id: item.id,
        isactive: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/saveApprisalLevelIsactive", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.apprisal_level_list = res.data.apprisal_level_list;
            this.showSnackbar("green", "Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    editApprisalLevel() {
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/editApprisalLevel", this.editedItem)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.apprisal_level_list = res.data.apprisal_level_list;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else if (res.data.flag == "NO") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
          this.dialog_edit = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    editEvaluationParameter(item) {
      this.editedItem.id = item.id;
      this.editedItem.name = item.name;
      this.editedItem.marks = item.marks;
      this.editedItem.sortorder = item.sort_order;
      this.editedItem.academicyear = item.academicyear;
      this.editedItem.isactive = item.isactive;
      this.dialog_edit = true;
    },
    clearData() {
      this.name = "";
      this.marks = "";
      this.sortorder = "";
    },
    saveApprisalLevel() {
      const data = {
        ay: this.ay,
        name: this.name,
        marks: this.marks,
        sortorder: this.sortorder,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/saveApprisalLevel", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.apprisal_level_list = res.data.apprisal_level_list;
            this.clearData();
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
          this.name = "";
          this.marks = "";
          this.sortorder = "";
        });
    },
    onLoad() {
      axios
        .post("SelfAppriasalMaster/apprisalLevelHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list),
              (this.apprisal_level_list = res.data.apprisal_level_list),
              (this.ay = res.data.current_ay);
            this.overlay = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
  computed: {
    bookList1() {
      return this.apprisal_level_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>

